module.exports = __webpack_public_path__ + "static/media/3.f5a2117c.png";